import { z } from "zod";

import { AmplitudeEventIds } from "../constants";

import { amplitudeEvent } from "./base";

export const CreateCreativeAnalyticsSavedViewEvent = amplitudeEvent(
  {
    id: AmplitudeEventIds.CREATE_CREATIVE_ANALYTICS_SAVED_VIEW,
    camelCaseName: "createCreativeAnalyticsSavedView",
    label: "Create Creative Analytics Saved View",
  },
  {
    /* Eventually, we will want to include the ID of the created saved view in the event details.
       However, that requires modifying the endpoint responsible for upserting creative analytics
       saved views.  For now, we will just omit. */
    savedView: z.object({
      name: z.string(),
    }),
    /* savedViewConfig: z.object({
         attributionWindow: AttributionWindows.schema,
         metrics: z.array(z.string()),
         attributionModel: z.string(),
         heroMetric: z.string(),
         groupByAdName: z.boolean(),
         creativeType: z.nativeEnum(CreativesTypeEnum).nullable(),
         searchText: z.string().nullable(),
         status: z.nativeEnum(CreativesStatusEnum).nullable(),
         sortingOrder: z.nativeEnum(CreativesSortingOrder),
         platforms: z.array(z.nativeEnum(CreativePlatformEnum)),
         dateRange: z.union([DateIntervalSchema, DateRanges.schema]),
         metricFilters: z.object({
           clauseType: z.nativeEnum(CreativesFilterClauseTypeEnum),
           metricClauses: z.array(
             z.object({
               customComposed: z.boolean(),
               operator: z.nativeEnum(CreativesFilterClauseValueOperatorsEnum),
               type: CreativeMetricTypes.schema,
               value: z.number(),
               metric: z.object({
                 details: z
                   .object({
                     accountingMode: z.string().optional(),
                     am: z.string().optional(),
                     aw: z.string().optional(),
                     type: z.string().optional(),
                   })
                   .optional(),
                 id: z.string(),
                 metric: z.string(),
               }),
             }),
           ),
         }),
       }), */
  },
);

export const SelectCreativeAnalyticsSavedView = amplitudeEvent(
  {
    id: AmplitudeEventIds.SELECT_CREATIVE_ANALYTICS_SAVED_VIEW,
    camelCaseName: "selectCreativeAnalyticsSavedView",
    label: "Select Creative Analytics Saved View",
  },
  {
    savedView: z.object({
      id: z.number(),
      name: z.string(),
      isTemplate: z.boolean(),
    }),
  },
);

export const CreateOverviewSavedViewEvent = amplitudeEvent(
  {
    id: AmplitudeEventIds.CREATE_OVERVIEW_SAVED_VIEW,
    camelCaseName: "createOverviewSavedView",
    label: "Create Overview Saved View",
  },
  {
    savedView: z.object({
      id: z.number(),
      name: z.string(),
    }),
    // savedViewFilters: OverviewFiltersSchema,
  },
);

export const SelectOverviewSavedViewEvent = amplitudeEvent(
  {
    id: AmplitudeEventIds.SELECT_OVERVIEW_SAVED_VIEW,
    camelCaseName: "selectOverviewSavedView",
    label: "Select Overview Saved View",
  },
  {
    savedView: z.object({
      id: z.number(),
      name: z.string(),
      isTemplate: z.boolean(),
    }),
    savedViewFilters: z.object({
      accountingMode: z.string(),
      attributionModel: z.string(),
      attributionWindow: z.string(),
      timeGranularity: z.string(),
      dateRange: z.any(),
      compareDateRange: z.any().optional(),
    }),
  },
);

export const CreateSalesSavedViewEvent = amplitudeEvent(
  {
    id: AmplitudeEventIds.CREATE_SALES_SAVED_VIEW,
    camelCaseName: "createSalesSavedView",
    label: "Create Sales Saved View",
  },
  {
    savedView: z.object({
      id: z.number(),
      name: z.string(),
    }),
  },
);

export const SelectSalesSavedView = amplitudeEvent(
  {
    id: AmplitudeEventIds.SELECT_SALES_SAVED_VIEW,
    camelCaseName: "selectSalesSavedView",
    label: "Select Sales Saved View",
  },
  {
    savedView: z.object({
      id: z.number(),
      name: z.string(),
      isTemplate: z.boolean(),
    }),
  },
);

export const SAVED_VIEW_EVENTS = [
  SelectCreativeAnalyticsSavedView,
  SelectOverviewSavedViewEvent,
  SelectSalesSavedView,
  CreateCreativeAnalyticsSavedViewEvent,
  CreateOverviewSavedViewEvent,
  CreateSalesSavedViewEvent,
] as const;
